/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * Refers to the name of the system to be used to resolve the service id.
 * LOGISTICS_SERVICE_AUTHORITY :
 * https:\/\/amazon.awsapps.com\/workdocs\/index.html#\/document\/844fd1f442b95672c72a1f2d938065b8ad3d939c10b7190d472eab7b943bae83
 **/
export var ServiceIdNamespace;
(function (ServiceIdNamespace) {
    ServiceIdNamespace["LOGISTICS_SERVICE_AUTHORITY"] = "LOGISTICS_SERVICE_AUTHORITY";
})(ServiceIdNamespace || (ServiceIdNamespace = {}));
